import * as types from 'src/redux/constants';

export const loginFromKaruna = (value) => ({
  type: types.LOGIN_FROM_KARUNA,
  payload: {
    value,
  },
});
